export const formatAmount = (amount: string | number) => Number(amount).toFixed(2)

export const formatDisplayExchangeRate = (currency: string, exchangeRate?: string) => {
  if (currency === 'USD') return '1.0000'
  if (!exchangeRate) return '-'

  const rate = Number(exchangeRate)
  if (!Number.isFinite(rate) || rate === 0) return '-'

  return (1 / rate).toFixed(4)
}
